// Read-only mock of the Supabase client, backed by embedded JCCC demo data.
import { JCCC_DEMO } from '../data/jcccDemo';

const TABLES = { requisitions: JCCC_DEMO.requisitions, orders: JCCC_DEMO.orders };

class MockQuery {
  constructor(table) {
    this.rows = (TABLES[table] || []).map((r) => ({ ...r }));
    this._single = false; this._write = false;
  }
  select() { return this; }
  insert() { this._write = true; return this; }
  update() { this._write = true; return this; }
  upsert() { this._write = true; return this; }
  delete() { this._write = true; return this; }
  eq(col, val) { if (!this._write) this.rows = this.rows.filter((r) => String(r[col]) === String(val)); return this; }
  neq(col, val) { this.rows = this.rows.filter((r) => String(r[col]) !== String(val)); return this; }
  in(col, vals) { const set = vals.map(String); this.rows = this.rows.filter((r) => set.includes(String(r[col]))); return this; }
  gte(col, val) { this.rows = this.rows.filter((r) => String(r[col] ?? '') >= String(val)); return this; }
  lte(col, val) { this.rows = this.rows.filter((r) => String(r[col] ?? '') <= String(val)); return this; }
  gt(col, val) { this.rows = this.rows.filter((r) => String(r[col] ?? '') > String(val)); return this; }
  lt(col, val) { this.rows = this.rows.filter((r) => String(r[col] ?? '') < String(val)); return this; }
  ilike() { return this; }
  or() { return this; }
  order(col, opts = {}) {
    const asc = opts.ascending !== false;
    this.rows.sort((a, b) => (String(a[col] ?? '') < String(b[col] ?? '') ? -1 : 1) * (asc ? 1 : -1));
    return this;
  }
  limit(n) { this.rows = this.rows.slice(0, n); return this; }
  range(a, b) { this.rows = this.rows.slice(a, b + 1); return this; }
  single() { this._single = true; return this; }
  maybeSingle() { this._single = true; return this; }
  then(resolve, reject) {
    const data = this._write ? null : (this._single ? (this.rows[0] ?? null) : this.rows);
    return Promise.resolve({ data, error: null, count: this._write ? 0 : this.rows.length }).then(resolve, reject);
  }
}

export function createMockClient() {
  return {
    from(table) { return new MockQuery(table); },
    auth: {
      signInWithPassword: async () => ({ data: null, error: null }),
      signOut: async () => ({ error: null }),
      getSession: async () => ({ data: { session: null }, error: null }),
    },
    rpc: async () => ({ data: null, error: null }),
  };
}
